<!--
 * @Description: 
 * @Autor: 
 * @Date: 2021-10-15 17:37:58
 * @LastEditors: lzw
 * @LastEditTime: 2021-10-15 18:08:10
 * @FilePath: \燃气B端\src\views\business\monitor\components\renderEnum.vue
-->
<template functional>
  <span :style="{ color: props.showObj.color }">{{ props.showObj.text }}</span>
</template>
<script>
export default {
  props: ['showObj']
}
</script>




// WEBPACK FOOTER //
// src/views/business/monitor/components/renderEnum.vue